/**
 * Detail bundle for a single `:FunctionLogicDiagram` (`$fldId` param).
 *
 * Returns:
 *   - `diagram`    — the node itself
 *   - `solver`     — owning `(:LogicSolver)-[:CONTAINS]->`
 *   - `site`       — solver `[:PART_OF]->(:Site)`
 *   - `points`     — `[:CONTAINS]->(:SafetyPoint)` children
 *   - `functions`  — `(:ProtectiveFunction)-[:IMPLEMENTED_BY]->` this FLD
 *
 * Bounded by `LIMIT 1`. Related lists are collected.
 */
export const PLANT_FUNCTION_LOGIC_DIAGRAM_DETAIL_CYPHER = `
            MATCH (fld:FunctionLogicDiagram {id: $fldId})
            OPTIONAL MATCH (ls:LogicSolver)-[:CONTAINS]->(fld)
            OPTIONAL MATCH (ls)-[:PART_OF]->(site:Site)
            OPTIONAL MATCH (fld)-[:CONTAINS]->(sp:SafetyPoint)
            OPTIONAL MATCH (pf:ProtectiveFunction)-[:IMPLEMENTED_BY]->(fld)
            RETURN fld AS diagram,
                   ls AS solver,
                   site,
                   collect(distinct sp) AS points,
                   collect(distinct pf) AS functions
            LIMIT 1
          `
